import { userPermission } from '@/constants';
import ShareList from '@/views/ShareManagement/ShareList/index.vue';
import ShareManagementConfig from '@V/ShareManagement/ShareConfig/index.vue';
import { pageAuthorization, onlyForDistributorUser, } from '@/router-middleware';
import { routeName } from '@/constants/routeName';
import basicOptions from '@/router/basic-options';
export default [
    {
        path: 'share-management',
        name: routeName.SHARE_MANAGEMENT,
        component: ShareList,
        meta: {
            ...basicOptions,
            middleware: [
                pageAuthorization(userPermission.P_GET_SHARE_MANAGEMENT()),
                onlyForDistributorUser,
                ...basicOptions.middleware,
            ],
        },
    },
    {
        path: 'share-management/share-config/:agencyHubId',
        name: routeName.SHARE_MANAGEMENT_CONFIG,
        component: ShareManagementConfig,
        meta: {
            ...basicOptions,
            middleware: [
                pageAuthorization(userPermission.P_GET_SHARE_MANAGEMENT(), true),
                onlyForDistributorUser,
                ...basicOptions.middleware,
            ],
        },
    },
];
